import React from 'react';
import SwipeableViews from 'react-swipeable-views';
import { SliderProps } from './types';

export const Slider: React.FC<SliderProps> = ({
  index,
  onChangeIndex,
  style,
  slideStyle,
  children,
}) => (
  <SwipeableViews
    index={index}
    onChangeIndex={onChangeIndex}
    style={style}
    containerStyle={style}
    slideStyle={slideStyle}
    ignoreNativeScroll
    disableLazyLoading
  >
    {children}
  </SwipeableViews>
);
